import base from "./base";
import { extendTheme } from "./utils";

export default extendTheme(base, {
    primary: '#bcbcbc',
    primaryDark: '#bcbcbc',

    logoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/choice-logo.png',
    smallLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/choice-small.png',
    loadingLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/choice-logo.png',

    availableProducts: ["Schadenmeldung", "smartKV", "Haftpflichtschaden", "Kaskoschaden"],
});